import { useParams, useNavigate } from "react-router-dom";
import { useGetGalleryImagesQuery } from "./galleryImagesApiSlice";
import EditGalleryImageForm from "./EditGalleryImageForm";

const EditGalleryImage = () => {

  const { id } = useParams();
  const navigate = useNavigate();

  // Fetch images list (already cached by RTK Query)
  const {
    data,
    isLoading,
    isError,
    error
  } = useGetGalleryImagesQuery({
    page: 1,
    limit: 100
  });

  if (isLoading) {
    return <p className="category-container">Loading image...</p>;
  }

  if (isError) {
    return (
      <p className="category-container">
        Error: {error?.data?.message || "Failed to load image"}
      </p>
    );
  }

  const image = data?.data?.find(img => img._id === id);

  if (!image) {
    return (
      <p className="category-container">
        Image not found
      </p>
    );
  }

  return (
    <div className="category-container">

      <EditGalleryImageForm image={image} />

    </div>
  );

};

export default EditGalleryImage;
